<template>
  <span>
    {{name}} {{lastName}}
  </span>
</template>
<script>
import { getGuestName, getGuestLastName } from '@/lib/helpers/GuestName'
export default {
  props: {
    guest: Object,
  },
  computed: {
    name () {
      return getGuestName(this.guest)
    },
    lastName () {
      return getGuestLastName(this.guest)
    },
  },
}
</script>
